<ng-container *transloco="let t ">
  <div class="relative flex flex-col w-full h-full">

    <!-- Dismiss button -->
    <div class="absolute top-0 right-0 pt-4 pr-4 flex items-start gap-2">
      <!-- Slot custom (es. riepilogo) -->
      <div class="text-xs sm:text-sm leading-tight text-right whitespace-nowrap opacity-90">
        <ng-content select="[dialogHeaderRight]"></ng-content>
      </div>

      <!-- Close -->
      @if (data?.close) {
        <button mat-icon-button (click)="close$.emit()">
          <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
      }
    </div>
    <!-- Content -->
    <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start pl-6 pt-6">

      <!-- Icon -->
      @if (data?.icon?.name && !this.isScreenSmall) {
        <div
          class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full"
                    [ngClass]="{'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600': data.icon.color === 'primary',
                            'text-accent-600 bg-accent-100 dark:text-accent-50 dark:bg-accent-600': data.icon.color === 'accent',
                            'text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600': data.icon.color === 'warn',
                            'text-gray-600 bg-gray-100 dark:text-gray-50 dark:bg-gray-600': data.icon.color === 'basic',
                            'text-blue-600 bg-blue-100 dark:text-blue-50 dark:bg-blue-600': data.icon.color === 'info',
                            'text-green-500 bg-green-100 dark:text-green-50 dark:bg-green-500': data.icon.color === 'success',
                            'text-amber-500 bg-amber-100 dark:text-amber-50 dark:bg-amber-500': data.icon.color === 'warning',
                            'text-red-600 bg-red-100 dark:text-red-50 dark:bg-red-600': data.icon.color === 'error'
                            }">
          <mat-icon
            class="text-current"
          [svgIcon]="data.icon.name"></mat-icon>
        </div>
      }

      <ng-container>
        <div
          class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 space-y-1 text-center sm:text-left w-full"
          style="align-self: center">

          <!-- Title -->
          <ng-container>
            <div
              class="text-xl leading-6 font-medium mb-4"
            [innerHTML]="data.title || t('dialog.attention') | safeHtml"></div>
          </ng-container>

          @if (data.message) {
            <div
              class="text-secondary"
              style="padding-bottom: 10px"
            [innerHTML]="data.message | safeHtml"></div>
          }
          <div matDialogContent="">
            <ng-content class="w-full"></ng-content>
          </div>

        </div>
      </ng-container>

    </div>


  </div>

</ng-container>
